import loadable from 'baas-ui/common/components/loadable';

import { Props } from './CodeEditor';

const CodeEditor = loadable(() => import('./CodeEditor'));

export { CodeEditor, Props };
